"use client";
import {
  StatsigClient,
  StatsigEvent,
  StatsigOptions,
  StatsigUser,
} from "@statsig/js-client";
import { StatsigSessionReplayPlugin } from "@statsig/session-replay";
import { StatsigAutoCapturePlugin } from "@statsig/web-analytics";
import { getStatsigEnvironment } from "@/flags/Statsig/getStatsigEnvironment";
import { skipTracking } from "./tracker";
import { getCookie } from "@cappelendamm/cookie";
import { Session } from "@cappelendamm/tracking";
import { SESSION_FIELDS } from "@cappelendamm/tracking";

const user: StatsigUser = {
  userID: getCookie(SESSION_FIELDS.IDENTIFIED_ID),
  customIDs: {
    stableID: getCookie(SESSION_FIELDS.CLIENT_ID),
  },
};

const options: StatsigOptions = {
  plugins: [new StatsigSessionReplayPlugin(), new StatsigAutoCapturePlugin()],
  environment: { tier: getStatsigEnvironment() }, // Optionally set the environment
  loggingEnabled: skipTracking() ? "disabled" : "browser-only",
};

const statsigApiKey = process.env.NEXT_PUBLIC_STATSIG_CLIENT_KEY;
if (!statsigApiKey) throw new Error("Missing statsig SDK key");
const statsigClient = new StatsigClient(statsigApiKey, user, options);

async function getStatsigClient() {
  if (statsigClient.loadingStatus === "Ready") return statsigClient;
  await statsigClient.initializeAsync();
  return statsigClient;
}

export async function trackStatsig(
  event: StatsigEvent,
  session: Pick<Session, "clientId" | "userId">,
) {
  const client = await getStatsigClient();
  await client.updateUserAsync({
    userID: session.userId ?? undefined,
    customIDs: {
      stableID: session.clientId,
    },
  });
  client.logEvent(event);
}
